const ROOT = '/assets/onboarding/reference-v2';
const NEXT: Record<string, string[]> = {
  welcome: ['interests', 'name'], interests: ['name', 'birth'], name: ['birth', 'request'],
  birth: ['request', 'generation'], request: ['generation', 'reading'], generation: ['reading'], reading: [],
};
const INTERESTS = ['relationships', 'money', 'career', 'decision', 'self', 'other'];
const pending = new Map<string, Promise<boolean>>();
const decoded = new Set<string>();

export const sceneUrl = (scene: string) => `${ROOT}/${scene}.webp`;

function warmImage(url: string): Promise<boolean> {
  const cached = pending.get(url);
  if (cached) return cached;
  const image = new Image();
  image.decoding = 'async';
  const result = new Promise<boolean>(resolve => {
    image.onload = async () => {
      try { await image.decode(); } catch { /* Loaded images remain usable in older WebViews. */ }
      decoded.add(url);
      resolve(true);
    };
    image.onerror = () => { pending.delete(url); resolve(false); };
    image.src = url;
  });
  pending.set(url, result);
  return result;
}

export function sceneIsReady(scene: string) { return decoded.has(sceneUrl(scene)); }

export function loadOnboardingScene(scene: string): Promise<boolean> {
  const urls = [sceneUrl(scene), ...(scene === 'interests' ? INTERESTS.map(id => sceneUrl(`interest-${id}`)) : [])];
  return Promise.all(urls.map(warmImage)).then(results => results.every(Boolean));
}

export async function prepareOnboardingScene(scene: string): Promise<boolean> {
  // Decoration must never trap the user if an image server is unavailable.
  let timeout: ReturnType<typeof setTimeout> | undefined;
  const result = await Promise.race([
    loadOnboardingScene(scene),
    new Promise<boolean>(resolve => { timeout = setTimeout(() => resolve(false), 2500); }),
  ]);
  clearTimeout(timeout);
  return result;
}

export function warmUpcomingScenes(scene: string) {
  for (const next of NEXT[scene] ?? []) void prepareOnboardingScene(next);
}
